import Vue from 'vue';
import AppStore from './store';
import App from './App';
import Symbol from 'es6-symbol'; // ie11対応

require('idempotent-babel-polyfill');

const debug = true;
const store = new AppStore(debug);
let modalVue = new Vue({
  el: '#sukima-modal',
  store,
  template: '<App/>',
  components: {App},
});
window.modalVue = modalVue;
window.showLoginModal = (message) => {
  modalVue.$store.commit('setLoginIsShow', true);
};